import './product-review-summary.scss';

import { components } from 'gridstrap/lib/gs-components';
import { GSProductReviewSummary } from './product-review-summary';

components.register({
	selector: '.gs-ProductReviewSummary',
	controller: GSProductReviewSummary
});
